var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephoneBlue1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1009 29.1189C37.4421 27.4146 32.7268 24.2218 29.6363 24.2218C28.9205 24.2218 28.2955 24.3809 27.7842 24.7104C26.2731 25.6762 25.0687 26.4261 24.4892 26.4261C24.1711 26.4261 23.8302 26.142 23.0803 25.4944L22.9553 25.3807C20.8761 23.5742 20.4329 23.1083 19.6262 22.2675L19.4217 22.0516C19.274 21.9039 19.149 21.7676 19.024 21.6426C18.3196 20.9154 17.8083 20.3928 16.0017 18.3476L15.9222 18.2567C15.0587 17.2795 14.4905 16.6433 14.4565 16.1774C14.4224 15.7229 14.82 14.9844 15.8313 13.6096C17.0584 11.9507 17.1038 9.9055 15.979 7.53082C15.0814 5.65606 13.6157 3.86084 12.3204 2.28151L12.2068 2.14516C11.0933 0.781704 9.79798 0.0999756 8.35499 0.0999756C6.75293 0.0999756 5.42356 0.963498 4.7191 1.41798C4.66229 1.45207 4.60548 1.49752 4.54867 1.53161C2.96934 2.53147 1.82176 3.90629 1.39 5.30384C0.742355 7.40583 0.310594 10.1327 3.41246 15.8025C6.09392 20.7109 8.52542 24.0059 12.3885 27.9713C16.0244 31.6981 17.6379 32.9025 21.251 35.5158C25.2732 38.4245 29.1363 40.0947 31.8405 40.0947C34.3516 40.0947 36.3286 40.0947 39.1464 36.6974C42.1005 33.1297 40.8734 30.9482 39.1009 29.1189Z",
    fill: "#4792F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneBlue1);
export default __webpack_public_path__ + "static/media/telephoneBlue1.2bde3b4b47949fb53911f098b0723c71.svg";
export { ForwardRef as ReactComponent };